import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DictService} from "../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {OckImportService} from "../../../shared/services/ock-import.service";

@Component({
  selector: 'app-nip-add',
  templateUrl: './nip-add.component.html',
  styleUrls: ['./nip-add.component.scss']
})
export class NipAddComponent implements  OnInit, OnDestroy {

  nipForm: FormGroup;
  valueControl: FormControl;
  processingRequest = false;
  formValid = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private ockImportService: OckImportService
  ) {
    this.nipForm = fb.group({
      nip: this.valueControl = this.fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.nipForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.formValid = this.nipForm.valid);
  }


  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    this.router.navigate(['/ock/import/nip']);

  }

  sendForm(): void {
    this.processingRequest = true;
    this.ockImportService.sendNip(this.nipForm.value)
      .subscribe((response) => {
        this.snack.open('Pomyślnie dodano NIP', '', {
          duration: 2000,
        });
        this.router.navigate(['/ock/import/nip']);


        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania NIP wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.processingRequest = false;
      });
  }

}
